import HeroCarousel from '../../components/home/HeroCarousel';
import VideoSlide from '../../components/home/VideoSlide';
import GuaranteeSection from '../../components/home/GuaranteeSection';
import Testimonials from '../../components/home/Testimonials';
import UnlockSection from '../../components/home/UnlockSection';

function HomeWidgets() 
{
    return (
    <div>
     <div className="bg-white">
        <HeroCarousel />
      </div>

      <div className="bg-white py-3">
        <UnlockSection />
      </div>

      <div className="bg-white py-3">
        <VideoSlide />
      </div>

      <div className="bg-white py-3">
        <GuaranteeSection />
      </div>

      {/* <div className="bg-white py-3">
        <Testimonials />
      </div> */}
    </div>
)
}

export default HomeWidgets;
